import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const PAYPAL_DETAIL_URL = '/mc-user/web/bank/recharge/paypal-detail';

/**
 * Dialog chi tiết giao dịch nạp tiền PayPal: mã giao dịch, thời gian, trạng thái,
 * số icoin đã cộng và user được nhận icoin.
 */
export default class ModalPaypalDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            detail: null,
            loading: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.orderId && this.props.orderId !== prevProps.orderId) {
            this.getDetail(this.props.orderId);
        }
    }

    getDetail(orderId) {
        this.setState({ loading: true, detail: null });
        axios.get(global.config.apiDomain + PAYPAL_DETAIL_URL, {
            params: { id: orderId }
        }).then(res => {
            this.setState({
                detail: res.data?.data || null,
                loading: false,
            });
        }).catch(error => {
            this.setState({ loading: false });
            const msg = error.response?.data?.message || error.message || "Không lấy được chi tiết giao dịch";
            toast.error(msg);
        });
    }

    formatDateTime(value) {
        if (!value) return "—";
        return new Date(value).toLocaleString('vi-VN');
    }

    formatNumber(value) {
        if (value === null || value === undefined || value === "") return "—";
        return Number(value).toLocaleString('vi-VN');
    }

    renderStatusBadge(status) {
        if (status === "SUCCESS") {
            return <span className="badge badge-success badge-pill px-2 py-1">SUCCESS</span>;
        }
        if (status === "FAILED") {
            return <span className="badge badge-danger badge-pill px-2 py-1">FAILED</span>;
        }
        return <span className="badge badge-secondary badge-pill px-2 py-1">{status || '—'}</span>;
    }

    render() {
        const { detail, loading } = this.state;

        return (
            <div className="modal fade" id="modalPaypalDetail" tabIndex={-1} role="dialog" aria-labelledby="modalPaypalDetailLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalPaypalDetailLabel">Chi tiết giao dịch PayPal</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {loading && (
                                <div className="text-center text-muted py-4">
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Đang tải...
                                </div>
                            )}
                            {!loading && !detail && (
                                <div className="text-center text-muted py-4">Không có dữ liệu</div>
                            )}
                            {!loading && detail && (
                                <>
                                    <h6 className="font-weight-bold mb-2">Thông tin giao dịch</h6>
                                    <table className="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: '35%' }}>Mã đơn PayPal</th>
                                                <td>{detail.orderId || "—"}</td>
                                            </tr>
                                            <tr>
                                                <th>Transaction ID</th>
                                                <td>{detail.transactionId || "—"}</td>
                                            </tr>
                                            <tr>
                                                <th>Thời gian tạo đơn</th>
                                                <td>{this.formatDateTime(detail.addTime)}</td>
                                            </tr>
                                            <tr>
                                                <th>Cập nhật lần cuối</th>
                                                <td>{this.formatDateTime(detail.lastUpdate)}</td>
                                            </tr>
                                            <tr>
                                                <th>Trạng thái</th>
                                                <td>{this.renderStatusBadge(detail.status)}</td>
                                            </tr>
                                            <tr>
                                                <th>Số tiền</th>
                                                <td>{this.formatNumber(detail.amount)} {detail.currency || 'USD'}</td>
                                            </tr>
                                            <tr>
                                                <th>Icoin đã cộng</th>
                                                <td>{this.formatNumber(detail.icoin)}</td>
                                            </tr>
                                            <tr>
                                                <th>Nội dung</th>
                                                <td>{detail.memo || "—"}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <h6 className="font-weight-bold mb-2 mt-4">User được cộng icoin</h6>
                                    {detail.userId ? (
                                        <table className="table table-bordered table-sm">
                                            <tbody>
                                                <tr>
                                                    <th style={{ width: '35%' }}>UID</th>
                                                    <td>{detail.uid || "—"}</td>
                                                </tr>
                                                <tr>
                                                    <th>Tên</th>
                                                    <td>{detail.userName || "—"}</td>
                                                </tr>
                                                <tr>
                                                    <th>FacebookID</th>
                                                    <td>{detail.userId}</td>
                                                </tr>
                                                <tr>
                                                    <th>Số dư icoin hiện tại</th>
                                                    <td>{this.formatNumber(detail.userTotalIcoin)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Avatar</th>
                                                    <td>
                                                        {detail.userAvatar
                                                            ? <img src={detail.userAvatar} height={50} width={50} alt="avatar" />
                                                            : "—"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p className="text-muted font-italic">
                                            {detail.uid
                                                ? `Chưa tìm thấy user cho UID ${detail.uid}`
                                                : "Giao dịch chưa được gán user (chưa xử lí nạp)"}
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Đóng</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
